module.exports = __webpack_public_path__ + "static/what-are-altcoins-09e5a3a0a16c68a6d87adaf1f376e25d.svg";